import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import logodashheader from "../Assets/logo-dash-header.png";
import FeedBackImg from "../Assets/ratings-review.png";
import PayPalSecuredPaymentImg from "../Assets/paypal-secured-payment.png";
import {
  documentAllowedRepo,
  documentAllowed,
  name,
  platform,
  ApiEndpoint,
} from "../Constant";
import Footer from "../Components/footer";
import Header from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import { Input, Textarea, Select, File } from "../Components/input";
import Form from "../Components/form";
import {
  clearSession,
  RedirectNotLogin,
  RedirectContractor,
  getSession,
  UpdateState,
  getState,
  handleSubmit,
  BreedForm,
  AlertMessage,
  AlertMessageOut,
  serializeArray,
} from "../Components/function";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { DateTime } from "../Components/function";
import * as axios from "axios";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = "visitor") => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  if (type === "visitor") {
    return result.visitorId;
  } else {
    //return result.visitorId;
  }
};

class Resubmit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userID: "",
      data: [],
      scriptID: "",
      file: "",
      message: "",
      retry_times: 0,
    };
  }

  componentDidMount() {
    RedirectNotLogin();
    RedirectContractor();
    this.loadDataFromServer();
  }

  componentDidUpdate() {
    RedirectNotLogin();
    RedirectContractor();
  }

  loadDataFromServer = async () => {
    UpdateState(this, "loading", "1");

    let DeviceSid = await FingerPrint();

    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = new URLSearchParams({
      command: "fetch",
      cmd: "fetchresubmit",
      user_id: getSession("userID"),
    }).toString();

    axios
      .get(ApiEndpoint + "/fetchResult?" + datas, header)
      .then((response) => {
        UpdateState(this, "loading", "0");

        if (response?.data?.retry == true) {
          let retryTimes =
            getState(this, "retry_times") >= 0 &&
            getState(this, "retry_times") != ""
              ? getState(this, "retry_times")
              : "";
          if (retryTimes != "") {
            if (getState(this, "retry_times") < 15) {
              setTimeout(function () {
                UpdateState(
                  this,
                  "retry_times",
                  getState(this, "retry_times") + 1
                );
                this.loadDataFromServer();
              }, 4000);
            }
          }
        }

        if (response?.data?.error == false && response?.data?.error != true) {
          //alert(JSON.stringify(response?.data?.data));
          UpdateState(
            this,
            "data",
            response?.data?.data.length > 0 ? response?.data?.data : []
          );
          UpdateState(
            this,
            "submit_status",
            response?.data?.submit_status != ""
              ? response?.data?.submit_status
              : "0"
          );
          UpdateState(
            this,
            "resubmit_file_cost",
            response?.data?.resubmit_file_cost != ""
              ? response?.data?.resubmit_file_cost
              : "0"
          );
          UpdateState(
            this,
            "show_pay_button",
            response?.data?.show_pay_button != ""
              ? response?.data?.show_pay_button
              : "0"
          );
          UpdateState(this, "message", "");
          UpdateState(this, "loading", "0");
        } else if (response?.data?.error != false) {
          AlertMessage(this, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            this,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          this,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        this.loadDataFromServer();
      });
  };

  render() {
    return (
      <div className="App AppWrap">
        <Header self={this} />
        <SideBar self={this} />

        <div className="App iBG dash-dash">
          <div className="containers">
            {/*<div className="card-lt">

    <div>Hi, {getSession('name')} - {getSession('userID')}</div>
    </div>*/}

            <div className="card-lt-wrap">
              <div className="card-lt">
                <div className="card-form-lt">
                  <small>
                    At this stage, you are expected to make a part payment of
                    $300. The balance of $500 is due after your paper is
                    accepted for publication. Please <b>pay now</b> before
                    re-submitting your paper
                  </small>
                  <br />
                  <br />

                  <div className="title-lt">Resubmit a File</div>

                  {getState(this, "loading") == "1" ? (
                    <div className="table-loader">
                      <div className="overlay">
                        <div className="overlay__inner">
                          <div className="overlay__content">
                            <span className="spinner"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <Form route="submit">
                    <div
                      className="warning"
                      style={{ margin: "0px" }}
                      hidden={
                        getState(this, "resubmit_file_cost") < 1 ||
                        getState(this, "show_pay_button") < 1
                      }
                    >
                      Resubmission fee is{" "}
                      <b>${getState(this, "resubmit_file_cost")}</b>.
                    </div>

                    {AlertMessageOut(this)}

                    <Select
                      wrapperClass="form-group-lt"
                      inputClass="input-lt"
                      inputState="scriptID"
                      inputPlaceholder="-- Select Script to Resubmit --"
                      inputOptions={
                        getState(this, "data") ? getState(this, "data") : ""
                      }
                      inputRequired="required"
                      self={this}
                    />

                    <small>
                      Upload manuscript without your names. No PDF format
                    </small>

                    <File
                      wrapperClass="form-group-lt"
                      inputClass="input-lt"
                      inputState="file"
                      inputPlaceholder="Upload File"
                      inputAccept={documentAllowed}
                      self={this}
                    />

                    <stripe-buy-button
                      buy-button-id="buy_btn_1RmvUXHcUznD8EhEmndNBF1h"
                      publishable-key="pk_live_51MBLBbHcUznD8EhEjlQeBwsfxKNsEn3cy2lYwh9ZPY9q7cTFp66bFGaswlN3R6veKwUtk1PulSrO9say41EmrDsx008RmrlFN2"
                    ></stripe-buy-button>

                    <Button
                      wrapperClass="form-group-lt"
                      buttonClass="button-lt"
                      buttonText="RESUBMIT"
                      buttonAction="resubmit_file"
                      self={this}
                    />

                    {/* <div
                      className="warning-no"
                      style={{ margin: "0px" }}
                      hidden={
                        getState(this, "resubmit_file_cost") < 1 ||
                        getState(this, "show_pay_button") < 1
                      }
                    >
                      <img
                        src={PayPalSecuredPaymentImg}
                        alt="PayPal Secured Payment"
                        style={{ maxWidth: "100%", maxHeight: "100px" }}
                      />
                    </div> */}
                  </Form>
                </div>
              </div>

              <Footer classX="dash-footer" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Resubmit;
